import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useEffect, useState } from "react";
import { ResolveThunks, connect } from "react-redux";
import { css } from "styled-components";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import Zone from "@insite/client-framework/Components/Zone";


const mapStateToProps = (state: CustomApplicationState) => {
    const userRoles = state.ADIGlobalData.ADIUserRoleStore;
    const session = state.context.session;
    return {
        userRoles,
        session,
    };
};

const mapDispatchToProps = {
};

export interface CCTokenizationStyles {
    text?: TypographyPresentationProps;
}

export const ccTokenizationStyles: CCTokenizationStyles = {
    text: {
        css: css`
        `,
    },
};


interface OwnProps extends WidgetProps {
}

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const styles = ccTokenizationStyles;
const ADIAddNewUser: FC<Props> = ({
    session,
    id,
    userRoles,
    history,
}) => {
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const isFullAccess = userRoles.fullAccess;
    const redirectToSignIn = () => history.push("/MyAccount/signin");
    useEffect(() =>{
        {!isAuthenticated && redirectToSignIn()}
    },[])
     return (
        (isAuthenticated && isFullAccess) ?
           <Zone contentId={id} zoneName="Content00" /> 
           :<></>
        )
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ADIAddNewUser)),
    definition: {
        displayName: "Add a new user",
        icon: "branch",
        fieldDefinitions: [

        ],
        group: "Common",
    },
};

export default widgetModule;
